<template>
    <v-app>
        <v-app-bar color="primary" density="comfortable">
            <v-app-bar-nav-icon v-if="!isLoginRoute" @click="drawer = !drawer" />
            <v-app-bar-title>Pavo</v-app-bar-title>
            <v-spacer />
            <v-btn icon="mdi-theme-light-dark" @click="toggleTheme" />
            <v-menu v-if="auth.user">
                <template #activator="{ props }">
                    <v-chip v-bind="props" class="mr-3" prepend-icon="mdi-account-circle" link>
                        {{ auth.user.name }}
                    </v-chip>
                </template>
                <v-list density="compact">
                    <v-list-item prepend-icon="mdi-logout" title="Logout" @click="logout" />
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-navigation-drawer v-if="!isLoginRoute" v-model="drawer">
            <v-list nav density="compact">
                <v-list-item
                    prepend-icon="mdi-view-dashboard"
                    title="Dashboard"
                    :to="{ name: 'Dashboard' }"
                />
                <v-list-item
                    prepend-icon="mdi-calendar-month"
                    title="Calendar"
                    :to="{ name: 'Calendar' }"
                />

                <v-list-subheader class="module-events">Events</v-list-subheader>
                <v-list-item
                    prepend-icon="mdi-calendar-multiple"
                    title="Conferences"
                    :to="{ name: 'CmsConferences' }"
                />
                <v-list-item
                    prepend-icon="mdi-file-chart"
                    title="Event Reports"
                    :to="{ name: 'CmsReports' }"
                />

                <v-list-subheader class="module-registration">Registration</v-list-subheader>
                <v-list-item
                    prepend-icon="mdi-account-multiple"
                    title="Individuals"
                    :to="{ name: 'SacsIndividuals' }"
                />
                <v-list-item
                    prepend-icon="mdi-domain"
                    title="Industry Colleagues"
                    :to="{ name: 'SacsColleagues' }"
                />
                <v-list-item
                    prepend-icon="mdi-cash-multiple"
                    title="Conferences &amp; Fees"
                    :to="{ name: 'SacsConferences' }"
                />
                <v-list-item
                    prepend-icon="mdi-file-chart-outline"
                    title="Registration Reports"
                    :to="{ name: 'SacsReports' }"
                />
                <v-list-item prepend-icon="mdi-email" title="Email" :to="{ name: 'SacsEmail' }" />
                <v-list-item
                    prepend-icon="mdi-checkbox-marked-circle-outline"
                    title="Data Quality"
                    :to="{ name: 'SacsQuality' }"
                />

                <v-list-subheader>Admin</v-list-subheader>
                <v-list-item
                    prepend-icon="mdi-table-cog"
                    title="Lookup Tables"
                    :to="{ name: 'Lookups' }"
                />
                <v-list-item
                    prepend-icon="mdi-silverware-fork-knife"
                    title="Facility Menus"
                    :to="{ name: 'FacilityMenus' }"
                />
                <v-list-item prepend-icon="mdi-account-cog" title="Users" :to="{ name: 'Users' }" />
            </v-list>
        </v-navigation-drawer>
        <v-main>
            <router-view />
        </v-main>
    </v-app>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useTheme } from "vuetify";
import { useAuthStore } from "@/store/auth";

const drawer = ref(true);
const theme = useTheme();
const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const isLoginRoute = computed(() => route.name === "Login");

function toggleTheme() {
    theme.global.name.value = theme.global.current.value.dark ? "light" : "dark";
}

async function logout() {
    await auth.logout();
    await router.push({ name: "Login" });
}
</script>

<style lang="scss">
.module-events {
    color: rgb(var(--v-theme-primary)) !important;
    font-weight: 600;
}

.module-registration {
    color: rgb(var(--v-theme-secondary)) !important;
    font-weight: 600;
}

.cms-page-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.cms-page-actions {
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    gap: 12px;
    max-width: 100%;
    margin-left: auto;
}

.cms-mono {
    font-family: "Roboto Mono", ui-monospace, monospace;
    font-size: 0.85em;
}
</style>
